module.exports = __webpack_public_path__ + "static/media/Logo_King_Arthur_Groep_web.5b8ddb27.jpg";